export default function findUnsavedMessageElement(listingId) {
  return document.getElementById(`listing-unsaved-${listingId}`);
}
